module.exports = __webpack_public_path__ + "static/media/6COPUOS4.fd26af6b.jpg";